import FlashcardReview from "./FlashcardReview";
import { motion } from "framer-motion";

export default function DailyReview() {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-10 md:py-14">
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-10"
      >
        <div className="eyebrow">Daily review</div>
        <h1 className="display-2 mt-2">
          Your <span className="grad-text">queue</span>
        </h1>
        <p className="text-[15px] text-[#B0AEBC] mt-3">
          Every card due today, from every study, in spaced-repetition order.
        </p>
      </motion.div>
      <FlashcardReview subcourseId={null} />
    </div>
  );
}
